<template>
    <div>
        <el-row>
            <el-col v-for="(val, idx) in innerValues" :key="idx" :span="22" class="array-select">
                <el-select
                    :key="idx"
                    :value="val"
                    @change="channelChange($event, idx)"
                    class="select-wrapper"
                    :placeholder="placeholder"
                    :filterable="!!filterable"
                    :multiple="!!multiple"
                >
                    <el-option v-for="(item, index) in options" :key="index" :value="item" :disabled="isOptionSelected(item)"></el-option>
                </el-select>
                <i
                    class="el-icon-remove icon"
                    v-show="(idx + 1 < innerValues.length || idx + 1 === options.length) && !(idx == 0 && innerValues.length === 1)"
                    @click="deleteItem(idx)"
                ></i>
                <i v-show="options.length - 1 > idx && idx + 1 === innerValues.length" class="el-icon-circle-plus icon" @click="addItem()"></i>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "ArraySelect",
    props: ["value", "placeholder", "options", "multiple", "filterable"],
    data() {
        const innerValues = (this.value || []).length ? this.value : [""];
        return {
            innerValues
        };
    },
    watch: {
        value: {
            handler(data) {
                this.innerValues = data;
            }
        }
    },
    methods: {
        channelChange(val, idx) {
            this.innerValues.splice(idx, 1, val);
            this.$emit("input", this.innerValues);
            setTimeout(() => {
                this.$emit("validate");
            });
        },
        isOptionSelected(option) {
            return this.innerValues.includes(option);
        },
        deleteItem(index) {
            this.innerValues.splice(index, 1);
            this.$emit("input", this.innerValues);
            setTimeout(() => {
                this.$emit("validate");
            });
        },
        addItem() {
            this.innerValues.push("");
            this.$emit("input", this.innerValues);
        }
    }
};
</script>

<style scoped>
.array-select {
    position: relative;
    height: 40px;
    width: 820px;
}
.select-wrapper {
    width: 780px;
}
.icon {
    position: absolute;
    font-size: 22px;
    margin-left: 8px;
    margin-top: 4px;
}
</style>
